import * as Yup from 'yup';
import i18n from 'i18n';

const schema = Yup.object().shape({
  Name: Yup.string().required(() => i18n.t('common:validation.fieldRequired')),
  Price: Yup.number().required(() => i18n.t('common:validation.fieldRequired')).nullable(),
  Description: Yup.string().required(() => i18n.t('common:validation.fieldRequired')),
  Order: Yup.number().required(() => i18n.t('common:validation.fieldRequired')),
  Info: Yup.string().required(() => i18n.t('common:validation.fieldRequired')),
})

export default schema;
